import React from 'react';
import { Chip } from '@mui/material';
import { SAGE, CREAM, WARM } from '../../theme';

const presets = {
  sage:    { bgcolor: SAGE[100],  color: SAGE[700],  borderColor: SAGE[200] },
  warm:    { bgcolor: '#fdf0e4',  color: '#8b5e34',  borderColor: WARM.accent },
  rose:    { bgcolor: '#fce8e8',  color: '#8b3a3a',  borderColor: WARM.rose },
  neutral: { bgcolor: CREAM[200], color: SAGE[600],  borderColor: SAGE[200] },
};

const Pill = ({ preset = 'sage', sx, ...props }) => {
  const colors = presets[preset] || presets.sage;
  return (
    <Chip
      size="small"
      sx={{
        fontFamily: "'Outfit', sans-serif",
        fontWeight: 500,
        fontSize: '0.75rem',
        bgcolor: colors.bgcolor,
        color: colors.color,
        border: `1px solid ${colors.borderColor}`,
        ...sx,
      }}
      {...props}
    />
  );
};

export default Pill;
